import { api } from './api';
import { env } from './env';

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

/** iOS delivers Web Push only to an app added to the home screen. */
export const needsInstall = () =>
  /iPhone|iPad/.test(navigator.userAgent) &&
  !window.matchMedia('(display-mode: standalone)').matches;

function key(base64: string) {
  const s = atob(
    (base64 + '='.repeat((4 - (base64.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/'),
  );
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
}

/** Subscribes this device and tells the server. Safe to repeat (e.g. after a different sign-in). */
export async function subscribePush(ask: boolean): Promise<NotificationPermission> {
  if (!pushSupported() || !env.vapidPublicKey) return 'denied';
  const perm = ask ? await Notification.requestPermission() : Notification.permission;
  if (perm !== 'granted') return perm;
  const reg = await navigator.serviceWorker.ready;
  const sub =
    (await reg.pushManager.getSubscription()) ??
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: key(env.vapidPublicKey),
    }));
  await api('/push/subscribe', sub.toJSON());
  return perm;
}
